import { History } from 'lucide-react';

const Header = () => {
  return (
    <div className="flex items-start gap-2.5 mb-1">
      <History className="w-4.5 h-4.5 text-secondary-600 mt-0.5 shrink-0" />
      <div>
        <h3 className="text-xs font-bold text-secondary-900">Visit History</h3>
        <p className="text-[10px] text-secondary-500 leading-normal">
          Previous visits and scheduling decisions for this treatment plan
        </p>
      </div>
    </div>
  )
}

export default Header;
